import { render, staticRenderFns } from "./SimpleXLS.vue?vue&type=template&id=5aa9049c&scoped=true&"
import script from "./SimpleXLS.vue?vue&type=script&lang=js&"
export * from "./SimpleXLS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa9049c",
  null
  
)

export default component.exports